export const getFormattedFilename = function (filename: string): string {
   return filename
      .replace(/[\s_-]+/g, ' ')
      .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1));
};
